import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Table,
  Tag,
} from 'antd';
import i18n from '../../config/i18n';
import {
  ACTIVE,
  PENDING,
  INACTIVE,
} from '../../constants/Status';

const styles = {
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  margin: {
    marginBottom: '60px',
  },
  tag: {
    [ACTIVE]: 'green',
    [PENDING]: 'blue',
    [INACTIVE]: 'orange',
  },
};

const PaymentHistory = ({
  payments,
}) => {
  const columns = [
    'id',
    'team',
    'plan',
    'price',
    'duration',
    'status',
    'date',
  ].map(key => ({
    title: key === 'id' ? '' : i18n.t(key),
    dataIndex: key,
    key,
  }));

  const data = payments.map((payment, index) => {
    const { status } = payment;
    return {
      ...payment,
      date: moment(payment.date).format('YYYY-MM-DD'),
      key: index,
      id: index + 1,
      status: <Tag color={styles.tag[status]}>{status}</Tag>,
    };
  });

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={data}
      pagination={false}
      style={styles.margin}
      title={() => (
        <h3 style={styles.center}>{i18n.t('paymentHistoryTitle')}</h3>
      )}
    />
  );
};

PaymentHistory.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    team: PropTypes.string.isRequired,
    plan: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    duration: PropTypes.number,
    status: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
  })),
};

PaymentHistory.defaultProps = {
  payments: [],
};

export default PaymentHistory;



// WEBPACK FOOTER //
// ./src/components/subscription/PaymentHistory.js